/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OrderItem } from './OrderItem';
import {
    OrderItemFromJSON,
    OrderItemFromJSONTyped,
    OrderItemToJSON,
    OrderItemToJSONTyped,
} from './OrderItem';
import type { NodataPageItemResVo } from './NodataPageItemResVo';
import {
    NodataPageItemResVoFromJSON,
    NodataPageItemResVoFromJSONTyped,
    NodataPageItemResVoToJSON,
    NodataPageItemResVoToJSONTyped,
} from './NodataPageItemResVo';

/**
 * 
 * @export
 * @interface IPageNodataPageItemResVo
 */
export interface IPageNodataPageItemResVo {
    /**
     * 
     * @type {Array<NodataPageItemResVo>}
     * @memberof IPageNodataPageItemResVo
     */
    records?: Array<NodataPageItemResVo>;
    /**
     * 
     * @type {number}
     * @memberof IPageNodataPageItemResVo
     */
    total?: number;
    /**
     * 
     * @type {number}
     * @memberof IPageNodataPageItemResVo
     */
    size?: number;
    /**
     * 
     * @type {number}
     * @memberof IPageNodataPageItemResVo
     */
    current?: number;
    /**
     * 
     * @type {Array<OrderItem>}
     * @memberof IPageNodataPageItemResVo
     */
    orders?: Array<OrderItem>;
    /**
     * 
     * @type {boolean}
     * @memberof IPageNodataPageItemResVo
     */
    optimizeCountSql?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IPageNodataPageItemResVo
     */
    searchCount?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IPageNodataPageItemResVo
     */
    optimizeJoinOfCountSql?: boolean;
    /**
     * 
     * @type {number}
     * @memberof IPageNodataPageItemResVo
     */
    maxLimit?: number;
    /**
     * 
     * @type {string}
     * @memberof IPageNodataPageItemResVo
     */
    countId?: string;
    /**
     * 
     * @type {number}
     * @memberof IPageNodataPageItemResVo
     */
    pages?: number;
}

/**
 * Check if a given object implements the IPageNodataPageItemResVo interface.
 */
export function instanceOfIPageNodataPageItemResVo(value: object): value is IPageNodataPageItemResVo {
    return true;
}

export function IPageNodataPageItemResVoFromJSON(json: any): IPageNodataPageItemResVo {
    return IPageNodataPageItemResVoFromJSONTyped(json, false);
}

export function IPageNodataPageItemResVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPageNodataPageItemResVo {
    if (json == null) {
        return json;
    }
    return {
        
        'records': json['records'] == null ? undefined : ((json['records'] as Array<any>).map(NodataPageItemResVoFromJSON)),
        'total': json['total'] == null ? undefined : json['total'],
        'size': json['size'] == null ? undefined : json['size'],
        'current': json['current'] == null ? undefined : json['current'],
        'orders': json['orders'] == null ? undefined : ((json['orders'] as Array<any>).map(OrderItemFromJSON)),
        'optimizeCountSql': json['optimizeCountSql'] == null ? undefined : json['optimizeCountSql'],
        'searchCount': json['searchCount'] == null ? undefined : json['searchCount'],
        'optimizeJoinOfCountSql': json['optimizeJoinOfCountSql'] == null ? undefined : json['optimizeJoinOfCountSql'],
        'maxLimit': json['maxLimit'] == null ? undefined : json['maxLimit'],
        'countId': json['countId'] == null ? undefined : json['countId'],
        'pages': json['pages'] == null ? undefined : json['pages'],
    };
}

export function IPageNodataPageItemResVoToJSON(json: any): IPageNodataPageItemResVo {
    return IPageNodataPageItemResVoToJSONTyped(json, false);
}

export function IPageNodataPageItemResVoToJSONTyped(value?: IPageNodataPageItemResVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'records': value['records'] == null ? undefined : ((value['records'] as Array<any>).map(NodataPageItemResVoToJSON)),
        'total': value['total'],
        'size': value['size'],
        'current': value['current'],
        'orders': value['orders'] == null ? undefined : ((value['orders'] as Array<any>).map(OrderItemToJSON)),
        'optimizeCountSql': value['optimizeCountSql'],
        'searchCount': value['searchCount'],
        'optimizeJoinOfCountSql': value['optimizeJoinOfCountSql'],
        'maxLimit': value['maxLimit'],
        'countId': value['countId'],
        'pages': value['pages'],
    };
}

